import { useContext } from "react";
import { trans } from "@/service/i18n/i18n";
import { UserContext } from "@/contexts/user-context";
import { createPath } from "@/service/routing/routing";
import { Button } from "@/components/ui/button";
import { SuperLink as Link } from "@/components/common/super-link";

export const DoctorSpecialization = ({
  access,
}: {
  access: { data: string[] };
}) => {
  const user = useContext(UserContext);

  return (
    <>
      <h2
        className={`text-card-foreground mb-6 text-center text-2xl font-semibold`}
      >
        {trans("hello")} {user.shortName},
      </h2>
      <p className={`text-foreground mb-2 text-base font-normal`}>
        Dostęp tylko dla lekarzy specjalistów i rezydentów z danej
        specjalizacji:{" "}
      </p>
      <div className="content-blocks">
        <ul className={`my-4 pl-5 md:pl-8`}>
          {access.data.map((item) => (
            <li key={item} className={`text-foreground list-disc text-sm`}>
              {item}
            </li>
          ))}
        </ul>
      </div>

      <Button asChild={true}>
        <Link href={createPath("homepage")} className={"mb-4 w-full"}>
          {trans("back_to_main_page")}
        </Link>
      </Button>
    </>
  );
};
